import React from 'react'
import { Button } from '@nextui-org/react'
import { Colors, Gradation } from '@/constants/styles/color'
import styles from './style.module.scss'

interface Props {
  gradation: string
  isDark?: boolean
  setGradation: (brightness: string) => void
}

const GradationSwitch: React.FC<Props> = ({ setGradation, gradation, isDark }) => {
  const buttonGroup = () => {
    if (!isDark) {
      return (
        <>
          <button
            className={styles.normalButton}
            style={{
              color: gradation === Gradation.BK_25 ? Colors.WHITE : Colors.LIGHT_GRAY,
              background: gradation === Gradation.BK_25 ? Colors.BLACK : Colors.WHITE,
            }}
            onClick={() => setGradation('light')}
          >
            <span>LIGHT</span>
          </button>
          <button
            className={styles.normalButton}
            style={{
              color: gradation === Gradation.BK_50 ? Colors.WHITE : Colors.LIGHT_GRAY,
              background: gradation === Gradation.BK_50 ? Colors.BLACK : Colors.WHITE,
            }}
            onClick={() => setGradation('normal')}
          >
            <span>NORMAL</span>
          </button>
          <button
            className={styles.normalButton}
            style={{
              color: gradation === Gradation.BK_75 ? Colors.WHITE : Colors.LIGHT_GRAY,
              background: gradation === Gradation.BK_75 ? Colors.BLACK : Colors.WHITE,
            }}
            onClick={() => setGradation('dark')}
          >
            <span>DARK</span>
          </button>
        </>
      )
    } else {
      return (
        <>
          <button
            className={styles.normalButton}
            style={{
              color: gradation === Gradation.BK_25 ? Colors.BLACK : Colors.GRAY,
              background: gradation === Gradation.BK_25 ? Colors.WHITE : Colors.DARK_GRAY,
            }}
            onClick={() => setGradation('light')}
          >
            <span>LIGHT</span>
          </button>
          <button
            className={styles.normalButton}
            style={{
              color: gradation === Gradation.BK_50 ? Colors.BLACK : Colors.GRAY,
              background: gradation === Gradation.BK_50 ? Colors.WHITE : Colors.DARK_GRAY,
            }}
            onClick={() => setGradation('normal')}
          >
            <span>NORMAL</span>
          </button>
          <button
            className={styles.normalButton}
            style={{
              color: gradation === Gradation.BK_75 ? Colors.BLACK : Colors.GRAY,
              background: gradation === Gradation.BK_75 ? Colors.WHITE : Colors.DARK_GRAY,
            }}
            onClick={() => setGradation('dark')}
          >
            <span>DARK</span>
          </button>
        </>
      )
    }
  }

  return (
    <div className={styles.gradationZone}>
      <div
        className={styles.card}
        style={{
          color: isDark ? Colors.GRAY : Colors.LIGHT_GRAY,
          background: isDark ? Colors.DARK_GRAY : Colors.WHITE,
        }}
      >
        <Button.Group
          animated
          css={{
            m: '4px',
          }}
        >
          <div className={styles.buttonGroup}>{buttonGroup()}</div>
        </Button.Group>
      </div>
    </div>
  )
}

export default GradationSwitch
